import './Header.css';
import {Outlet} from 'react-router-dom';
import {
  useApiRequest,
  useMetaData,
  useVisaRequest,
  useVisitor,
} from '@/query/hooks';
import ApplicationTimer from './ApplicationTimer';
import Country from '@/parsers/Country';
import {CountryFlag} from '@/components/common';
import {Button} from 'react-bootstrap';
import {WebSvg} from '@/assets';
import {Utility} from '@/utils';

const ApplicantName = () => {
  const {visitor} = useVisitor();
  return (
    <div className="d-flex align-items-center gap-1">
      <div style={{fontWeight: 600}}>Applicant name:</div>
      {visitor.full_name}
    </div>
  );
};

function Header() {
  const request = useVisaRequest();
  const api = useApiRequest();
  const meta = useMetaData();

  const downloadPdf = (pdfUrl: string) => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = request.fila_name;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onDownload = async () => {
    Utility.showLoader();
    try {
      const res = await api.downloadReceipt();
      downloadPdf(res.pdf_url);
    } catch (e) {
      /* empty */
    } finally {
      Utility.hideLoader();
    }
  };

  return (
    <div>
      <section className="header-part d-flex align-items-center justify-content-between p-4 pt-3 pb-3">
        <div className="headerLeft d-flex">
          <div className="companyLogo pe-3">
            <img src={meta.logo_image_url} height={'50'} />
          </div>
          {!request.bundle && (
            <div className="VisaLogo">
              <div
                className="d-flex align-items-center gap-2"
                style={{marginTop: '-8px'}}
              >
                <CountryFlag />
                <div className="country-name">{Country.country_visa_type}</div>
              </div>
            </div>
          )}
        </div>
        {request.code && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex header-right align-items-center">
              {request.expire_at && (
                <ApplicationTimer
                  expire_at={request.expire_at}
                  shouldShow={request.show_timer}
                />
              )}
              {<ApplicantName />}
              <div className="sep" />
              <div className="d-flex align-items-center gap-1">
                <div style={{fontWeight: 600}}>Application number:</div>
                {request.code}
              </div>
            </div>
            {!request.bundle && !!request.paid_at && (
              <Button
                onClick={onDownload}
                color="dark"
                className="download-button p-0 px-3 d-flex align-items-center ms-4"
                data-tooltip="Download Receipt"
              >
                <img src={WebSvg.DownloadIcon} />
              </Button>
            )}
          </div>
        )}
      </section>
      <Outlet />
    </div>
  );
}

export default Header;
